// src/GrupoContext.js
import React, { createContext, useState } from 'react';

export const GrupoContext = createContext();

export const GrupoProvider = ({ children }) => {
    const [grupo, setGrupo] = useState(null);

    return (
        <GrupoContext.Provider value={{ grupo, setGrupo }}>
            {children}
        </GrupoContext.Provider>
    );
};
